export const INVALID_SESSION_ID = "INVALID_SESSION_ID";
export const SESSION_HEADER = "x-session-id";

export const projectHumanReadableFields: {
  [key: string]: string;
} = {
  on_screen_prj: "Visible in map area",
  created: "Created At",
  id: "ID",
  updated: "Updated At",
  project_name: "Project Name",
  information: "Information",
  author: "Author",
  state: "State",
  technology: "Technology",
  project_size_mw: "Project Size (MW)",
  project_size_dc: "Project Size DC (MW)",
  storage_size_mwh: "Storage Size (MWh)",
  turbines: "Turbines",
  developer: "Developer",
  owner: "Owner",
  project_status: "Project Status",
  da_status: "DA Status",
  da_source: "DA Source",
  epbc_code: "EPBC Code",
  epbc_status: "EPBC Status",
  opennem: "Open Electricity",
  voltage: "Voltage (kV)",
  network: "Network",
  construction_type: "Construction Type",
  infrastructure_status: "Infrastructure Status",
  council_area: "Council Area",
  rez: "RE Zone/s",
  project_type: "Project Type",
};

/**
 * Main either result interface to be used for handling error states calling a function
 */
export type Result<T, E> =
  | {
      ok: T;
      err: null;
    }
  | {
      ok: null;
      err: E;
    };

export * from "./display-keys";
export * from "./project";
export * from "./infrastructure";
export * from "./map";
export * from "./user";
export * from "./changelog";
export * from "./fields";
export * from "./bootstrap";
export * from "./zone";
export * from "./scenarios";
export * from "./publish";
export * from "./preferences";
export * from "./container";
export * from "./estimates";
export * from "./organisation";
export * from "./entity";
export * from "./netzero";
export * from "./ai-filter";
export * from "./timeseries";
export * from "./preset";
